import { Http } from '@/repositories/HttpCommon'
import { getGlobalConfig } from '@/utils/globalConfig'

export async function getTermOfUseContent (countryCode, languageCode = 'en') {
  const key = `STATIC_CONTENT.TERM_OF_USE_${languageCode.toUpperCase()}_${countryCode.toUpperCase()}`
  const touUrl = getGlobalConfig(key)

  const response = await Http.get(touUrl, {})
  return response.data
}
